import { Badge } from "react-bootstrap";
import { Type } from "../actions/types";

interface Props {
  types: Type[];
}

const ProductTagsTypes = (props: Props) => {
  const { types } = props;

  return <>
    {types.map((type, index: number) => {
      return (
        <Badge bg="dark" key={index} className="mb-2 me-1">
          {type.name}
        </Badge>
      );
    })}
  </>
}

export default ProductTagsTypes;
